import bgImg from '@/assets/img/curved-images/top_bg.svg';
import { HomeLayout } from '@/components/layout/HomeLayout';
import { useMe } from '@/hooks/api/0050_me';
import { useWorkspaces } from '@/hooks/api/0100_workspaces';
import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export const Workspaces = () => {
  return (
    <>
      <HomeLayout>
        <main className="main-content mt-0">
          <div
            className="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
            style={{ backgroundImage: `url(${bgImg})` }}
          >
            <span className="mask bg-gradient-dark opacity-5"></span>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-5 text-center mx-auto">
                  <h1 className="text-white mb-2 mt-5">スペース選択</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
              <div className="col-xl-10 col-lg-10 col-md-10 mx-auto">
                <div className="card">
                  <div className="card-header d-flex align-items-center">
                    <h6 className="mb-0 col-md-6">スペース一覧</h6>
                    <div className="col-md-6 d-flex justify-content-end">
                      <Link to={`/workspaces/new`} className="btn bg-gradient-primary btn-icon">
                        <i className="fas fa-plus"></i>スペース新規作成
                      </Link>
                    </div>
                  </div>
                  <WorkspacesElement />
                </div>
              </div>
            </div>
          </div>
        </main>
      </HomeLayout>
    </>
  );
};

const WorkspacesElement = () => {
  const { data } = useWorkspaces();
  const { data: me } = useMe();
  const location = useLocation();
  const navigate = useNavigate();
  const fromLocation: string = location.state?.fromLocation;

  useEffect(() => {
    if (me == null) return;

    if (fromLocation) {
      if (fromLocation == 'sign_in') {
        // @ts-ignore
        window.Intercom('boot', {
          app_id: 'i2i99qtf',
          email: me.email,
          user_id: me.id,
          name: me.name,
        });
      }
      if (fromLocation == 'sign_up') {
        // @ts-ignore
        window.Intercom('boot', {
          app_id: 'i2i99qtf',
          email: me.email,
          user_id: me.id,
          created_at: Math.round(new Date().getTime() / 1000),
          name: me.name,
        });
      }
    }

    if (data && fromLocation) {
      if (data.length == 0) {
        navigate(`/workspaces/new`);
      }

      if (data.length == 1 && (fromLocation == 'sign_in' || fromLocation == 'sign_up')) {
        navigate(`/w/${data[0].identifier}`);
      }
    }
  }, [fromLocation, data, me]);

  if (data == null) return <div className="card-body pt-0"></div>;

  if (data.length == 0) {
    return (
      <div className="card-body pt-0">
        <h5>スペースがありません</h5>
        <p className="card-description text-sm">
          新規作成よりスペースを作成してください。
          <br />
          招待を受けたにも関わらずこの画面が表示されている場合は、登録したアドレスが招待を受けたアドレスと同一か確認をしてください。
        </p>
      </div>
    );
  }

  return (
    <div className="card-body pt-0">
      <div className="table-responsive">
        <table className="table align-items-center">
          <thead>
            <tr>
              <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">スペース名</th>
              <th className="text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                スペースID
              </th>
              <th className="text-secondary opacity-7" style={{ width: 146 }}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((w) => (
              <tr key={`ws-${w.id}`}>
                <td>
                  <div className="d-flex align-items-center">
                    <div>
                      <img src={w.logo_image_file_url} className="avatar avatar-sm me-3" />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h5 className="mb-0">{w.name}</h5>
                    </div>
                  </div>
                </td>
                <td className="text-end text-secondary text-xs font-weight-bold">{w.identifier}</td>
                <td>
                  {w.suspended ? (
                    <Link to={`/w/${w.identifier}`} className="btn btn-outline-danger disabled" data-toggle="tooltip">
                      利用停止中
                    </Link>
                  ) : (
                    <Link to={`/w/${w.identifier}`} className="btn btn-outline-info" data-toggle="tooltip">
                      スペースへ移動
                    </Link>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
